import { useContext } from 'react';

import { GridColumns, GridRows } from '@visx/grid';
import { DataContext } from '@visx/xychart';

import { useTickValues } from './axis/useTickValues';
import { DEFAULT_X_TICKS, DEFAULT_Y_TICKS } from './axis/utils';

type GridProps = {
  numYTicks?: number;
  numXTicks?: number;
};

export const Grid = ({ numYTicks = DEFAULT_Y_TICKS, numXTicks = DEFAULT_X_TICKS }: GridProps) => {
  const { yScale, xScale, innerWidth, theme, innerHeight, margin } = useContext(DataContext) || {};
  const { xTickValues, yTickValues } = useTickValues({ numXTicks, numYTicks });

  if (!yScale || !innerWidth || !xScale || !innerHeight) return null;

  const gridStroke = theme?.gridStyles?.stroke;

  return (
    <>
      <GridColumns
        data-testid="grid-columns"
        scale={xScale}
        tickValues={xTickValues}
        height={innerHeight}
        stroke={gridStroke}
        top={margin?.top}
      />
      <GridRows
        data-testid="grid-rows"
        scale={yScale}
        tickValues={yTickValues}
        width={innerWidth}
        stroke={gridStroke}
        left={margin?.left}
      />
    </>
  );
};
